
export const about = {
  title: "Sobre Salva Patas",
  subtitle: "Dedicados a la promoción de la adopción responsable de mascotas y su bienestar",
  missionTitle: "Nuestra Misión",
  missionText: "Nuestra misión es rescatar, rehabilitar y encontrar hogares seguros para mascotas abandonadas, mientras educamos a la comunidad sobre la importancia de la adopción responsable y el cuidado adecuado de las mascotas.",
  visionTitle: "Nuestra Visión",
  visionText: "Aspiramos a crear un mundo donde ninguna mascota sufra abandono, donde cada animal tenga un hogar y donde la adopción sea la primera opción para quienes desean una mascota.",
  historyTitle: "Nuestra Historia",
  historyText: [
    "Salva Patas nació en agosto de 2024 gracias a la visión de Alonso Arana, impulsado por el rescate de un perro llamado Astro. Lo que comenzó como un proyecto personal, pronto se convirtió en un equipo dedicado a una causa mayor: apoyar a los rescatistas de mascotas y encontrar hogares para animales necesitados.",
    "Con la incorporación de nuevos miembros en 2025, el equipo de Salva Patas se fortaleció para amplificar su impacto. Juntos, no solo gestionan rescates, sino que también promueven la adopción responsable y la concienciación sobre el bienestar animal, sirviendo como un puente vital entre mascotas sin hogar y familias que pueden ofrecerles una segunda oportunidad."
  ],
  valuesTitle: "Nuestros Valores",
  compassionTitle: "Compasión",
  compassionText: "Actuamos con amor y empatía hacia todos los animales.",
  responsibilityTitle: "Responsabilidad",
  responsibilityText: "Nos comprometemos con el bienestar de cada mascota.",
  communityTitle: "Comunidad",
  communityText: "Trabajamos juntos para hacer un cambio positivo.",
  joinCauseTitle: "Únete a Nuestra Causa",
  joinCauseText: "Ayúdanos a seguir salvando vidas y encontrando hogares para mascotas necesitadas",
  contactUs: "Contáctanos",
  teamMembers: [
    {
      name: "ALo",
      role: "Fundador",
      image: "", // Reemplaza con la ruta de tu imagen
      description: "Dedicada al rescate animal desde hace 10 años."
    },
  ],
  statistics: [
    {
      number: "500+",
      title: "Mascotas Adoptadas",
      description: "Desde nuestro inicio"
    },
    {
      number: "300+",
      title: "Familias Felices",
      description: "Han adoptado con nosotros"
    },
    {
      number: "100%",
      title: "Compromiso",
      description: "Con el bienestar animal"
    },
    {
      number: "24/7",
      title: "Disponibilidad",
      description: "Para emergencias"
    }
  ]
};

export const contact = {
  title: "Contáctanos",
  subtitle: "Estamos aquí para ayudarte con cualquier pregunta sobre adopciones",
  contactInfoTitle: "Información de Contacto",
  location: "Ubicación",
  locationText: "Lima, Perú",
  email: "Email",
  emailText: "salvapatasperu@gmail.com",
  phone: "Teléfono",
  phoneText: "+51 935 730 575",
  followUs: "Síguenos",
  instagram: "Instagram",
  instagramText: "@salvapatasoficial",
  fullName: "Nombre completo",
  message: "Mensaje",
  sendMessage: "Enviar mensaje",
  sending: "Enviando...",
  messageSentSuccess: "¡Mensaje enviado exitosamente!",
  messageSentError: "Error al enviar el mensaje. Por favor, intenta nuevamente."
};
